import React, {Component} from 'react';
import "./PagesMp.scss"

class PagesMp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: props.page
        }
    }

    pageClick(index, text = "") {
        let {page} = this.state;
        let count = page.count;
        page.count = count;
        let usedCount = Math.ceil(page.count / page.size);
        let newCount = Math.ceil(count / page.size);
        switch (index) {
            case count:
                if (usedCount !== newCount) {
                    page.index = count;
                } else {
                    page.index = index;
                }
                break;
            default:
                if (usedCount !== newCount) {
                    if (usedCount < newCount) {
                        page.index = index + 1;
                    } else {
                        page.index = index;
                    }
                } else {
                    page.index = index;
                }
                break;
        }
        if (text === "first") {
            page.index = 1;
        }
        if (text === "tail") {
            page.index = newCount;
        }
        this.props.callback(page.index);
        this.setState({})
    }

    getPageArr() {
        let {page} = this.state;
        let arr = [], pageArr;
        let pageCount = Math.ceil(page.count / page.size);
        for (let i = 1; i < pageCount + 1; i++) {
            arr.push(i);
        }
        switch (page.index) {
            case 1:
                pageArr = arr.slice(page.index - 1, page.index + 2);
                break;
            case pageCount:
                pageArr = arr.slice(page.index - 3, page.index + 1);
                break;
            default:
                pageArr = arr.slice(page.index - 2, page.index + 1);
                break;
        }
        if (pageCount < 3) {
            pageArr = arr.slice(0, pageCount + 1);
        }
        return pageArr;
    }

    render() {
        let {page} = this.state;
        let pageArr = this.getPageArr();
        return (
            <div className="pageMp">
                <div className="first"
                     onClick={this.pageClick.bind(this, 1, "first")}>
                    首页
                </div>
                <div className="upper"
                     onClick={this.pageClick.bind(this, page.index > 1 ? page.index - 1 : page.index)}>
                    上一页
                </div>
                {
                    pageArr.map((item, index) => {
                        return (
                            <div className={`item${item === page.index ? " in" : null}`}
                                 onClick={this.pageClick.bind(this, item)}
                                 key={index}>{item}</div>
                        )
                    })
                }
                <div className="lower"
                     onClick={this.pageClick.bind(this, page.index < Math.ceil(page.count / page.size) ? page.index + 1 : page.index)}>
                    下一页
                </div>
                <div className="tail"
                     onClick={this.pageClick.bind(this, Math.ceil(page.count / page.size), "tail")}>
                    尾页
                </div>
            </div>
        );
    }
}

export default PagesMp;
